function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.125 8.49794H29.8916V21.2074C29.8916 23.2751 28.2093 24.9574 26.1416 24.9574H3.98334V25.1908C3.98334 26.2263 4.82277 27.0658 5.85834 27.0658H30.125C31.1605 27.0658 32 26.2263 32 25.1908V10.3729C32 9.33738 31.1605 8.49794 30.125 8.49794Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0166 21.2074V6.80919C28.0166 5.77369 27.1772 4.93419 26.1416 4.93419H1.875C0.839437 4.93419 0 5.77369 0 6.80919V21.2074C0 22.2429 0.839437 23.0824 1.875 23.0824H26.1416C27.1771 23.0824 28.0166 22.2429 28.0166 21.2074ZM2.98756 8.17457H7.84312V10.0496H2.98756V8.17457ZM9.92 14.0329H2.98756V12.1579H9.92V14.0329ZM24.9707 20.0365H23.0957V18.1615H24.9707V20.0365Z",
  fill: "white"
});
function SvgVisitingCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitingCard);
export default __webpack_public_path__ + "static/media/visitingCard.5d443e16.svg";
export { ForwardRef as ReactComponent };